export interface Service {
  id: string;
  name: string;
  shortDesc: string;
  longDesc: string;
  image: string;
  icon: string;
  details: string[];
}

export const services: Service[] = [
  {
    id: 'make-ready',
    name: 'Make-Ready Remodeling',
    shortDesc: 'Prepare your Houston property for new occupants with precision and professional efficiency.',
    longDesc: 'Our make-ready remodeling service ensures your property is move-in ready with professional quality on every detail. Whether transitioning between tenants or preparing a property for sale, we deliver results that exceed expectations — on time and on budget.',
    image: 'https://public.readdy.ai/ai/img_res/94e7538a24871d2efb7a0aa6f484af46.jpg',
    icon: 'ri-home-gear-line',
    details: [
      'Interior painting & touch-ups',
      'Fixture replacement & updates',
      'Flooring repair & installation',
      'Drywall repair & patching',
      'Light carpentry & trim work',
      'Door & window repairs',
      'Tenant turnover solutions',
      'Deep cleaning preparation',
    ],
  },
  {
    id: 'flooring',
    name: 'Flooring',
    shortDesc: 'Elevate every room with premium flooring installation and expert craftsmanship.',
    longDesc: 'From hardwood and tile to luxury vinyl and laminate, our flooring specialists deliver flawless results that enhance your home\'s beauty and value. Every installation is measured, cut, and finished with precision that stands the test of time.',
    image: 'https://readdy.ai/api/search-image?query=premium%20hardwood%20floor%20installation%20luxury%20home%20warm%20oak%20wood%20tones%20upscale%20interior%20natural%20light%20close%20up%20elegant%20modern%20open%20plan%20living%20room%20beautiful%20wood%20grain%20texture%20clean%20polished%20pristine%20new%20flooring%20residential%20Houston%20Texas&width=740&height=480&seq=svc-fl-001&orientation=landscape',
    icon: 'ri-layout-grid-line',
    details: [
      'Hardwood floor installation',
      'Luxury vinyl plank (LVP)',
      'Tile & stone flooring',
      'Laminate installation',
      'Floor repair & refinishing',
      'Subfloor preparation',
      'Baseboard & trim installation',
      'Grout repair & sealing',
    ],
  },
  {
    id: 'drywall-painting',
    name: 'Drywall & Painting',
    shortDesc: 'Flawless walls, perfect finishes — transform your space with expert craftsmanship.',
    longDesc: 'Our drywall and painting team delivers smooth, professional results that transform any interior. From minor patching to full wall restoration, we ensure a premium finish that enhances your home and lasts for years.',
    image: 'https://readdy.ai/api/search-image?query=pristine%20freshly%20painted%20interior%20walls%20luxury%20residence%20smooth%20white%20finish%20bright%20elegant%20room%20natural%20light%20upscale%20home%20renovation%20clean%20crisp%20modern%20minimalist%20residential%20space%20Houston%20professional%20painting%20perfect%20smooth%20finish&width=740&height=480&seq=svc-dp-001&orientation=landscape',
    icon: 'ri-paint-brush-line',
    details: [
      'Interior & exterior painting',
      'Drywall installation & repair',
      'Texture matching & application',
      'Water damage restoration',
      'Popcorn ceiling removal',
      'Cabinet painting & refinishing',
      'Wall patching & skim coat',
      'Color consultation included',
    ],
  },
  {
    id: 'electrical',
    name: 'Electrical',
    shortDesc: 'Safe, reliable electrical services delivered by experienced professionals.',
    longDesc: 'Our experienced electrical team handles everything from outlet replacement to fixture installation, ensuring your home\'s electrical system is safe, efficient, and fully functional.',
    image: 'https://readdy.ai/api/search-image?query=modern%20designer%20pendant%20lighting%20installation%20luxury%20home%20ceiling%20elegant%20contemporary%20interior%20upscale%20warm%20glow%20beautiful%20light%20fixtures%20high%20end%20residential%20home%20clean%20sophisticated%20kitchen%20island%20interior%20Houston%20Texas&width=740&height=480&seq=svc-el-001&orientation=landscape',
    icon: 'ri-flashlight-line',
    details: [
      'Outlet & switch replacement',
      'Light fixture installation',
      'Ceiling fan installation',
      'GFCI outlet upgrades',
      'Electrical panel work',
      'Code compliance repairs',
      'Smoke & carbon detector install',
      'Dedicated circuit installation',
    ],
  },
  {
    id: 'plumbing',
    name: 'Plumbing',
    shortDesc: 'From leaks to full installations — professional plumbing done right the first time.',
    longDesc: 'Our plumbing experts resolve any issue with precision and professionalism. We handle everything from minor repairs to full fixture installations, ensuring your plumbing systems run flawlessly throughout your Houston home.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20master%20bathroom%20chrome%20matte%20faucet%20marble%20countertop%20upscale%20modern%20sink%20installation%20premium%20residential%20clean%20bright%20elegant%20spa%20like%20renovation%20Houston%20home%20professional%20plumbing%20pristine%20white%20grey%20tones&width=740&height=480&seq=svc-pl-001&orientation=landscape',
    icon: 'ri-drop-line',
    details: [
      'Faucet repair & replacement',
      'Toilet installation & repair',
      'Sink & drain installation',
      'Water heater services',
      'Leak detection & repair',
      'Garbage disposal installation',
      'Shower & tub installation',
      'Pipe repair & replacement',
    ],
  },
  {
    id: 'roofing',
    name: 'Roofing',
    shortDesc: 'Protect your most valuable investment with professional roofing services.',
    longDesc: 'Our roofing team provides comprehensive repair and maintenance services to keep your Houston home protected against the elements. From storm damage assessment to shingle replacement, we ensure your roof stands strong.',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20luxury%20residential%20home%20exterior%20newly%20installed%20premium%20dark%20grey%20roof%20shingles%20clear%20blue%20sky%20upscale%20Houston%20Texas%20elegant%20architecture%20clean%20professional%20roofing%20work%20suburban%20neighborhood%20pristine%20curb%20appeal&width=740&height=480&seq=svc-ro-001&orientation=landscape',
    icon: 'ri-building-2-line',
    details: [
      'Roof inspection & assessment',
      'Shingle repair & replacement',
      'Storm damage repairs',
      'Roof leak repair',
      'Flashing repair & replacement',
      'Gutter repair & cleaning',
      'Soffit & fascia repair',
      'Ventilation improvements',
    ],
  },
];
